import React from "react";
import styled from "styled-components";
import { H3, GridRow, Icon } from "../";
import { formatDate } from "../";
export const DatePickerHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled
}) => {
  const getYear = value => formatDate(value, {
    year: "numeric"
  });

  const getMonth = value => formatDate(value, {
    month: "long"
  });

  return React.createElement(Container, {
    xCenter: true,
    yCenter: true
  }, React.createElement(Nav, null, React.createElement(Previous, {
    name: "Previous",
    onClick: decreaseMonth,
    disabled: prevMonthButtonDisabled
  }), React.createElement(Next, {
    name: "Next",
    onClick: increaseMonth,
    disabled: nextMonthButtonDisabled
  })), React.createElement(Month, null, getMonth(date)), React.createElement(Year, null, getYear(date)));
};
const Container = styled(GridRow)`
  border-bottom: 1px solid ${props => props.theme.colors.disabledText};
  height: 59px;
  margin-bottom: 4px;
  min-width: 360px;
`;
const Year = styled(H3)`
  font-size: 22px;
`;
const Month = styled(Year)`
  margin-right: 8px;
`;
const IconStyle = styled(Icon)`
  cursor: pointer;
  path {
    fill: ${props => props.theme.colors.text};
  }
  &:hover {
    background-color: #f5f5f5;
    border-radius: 2px;
  }
`;
const Previous = styled(IconStyle)`
  margin-right: 16px;
`;
const Next = styled(IconStyle)`
  margin-right: 24px;
`;
const Nav = styled(GridRow)`
  left: 24px;
  position: absolute;
`;